import { useEffect, useState } from "react";
import { Outlet, useParams, Navigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import api from "../../lib/api";
import { SUPPORTED_LANGS, LangContext } from "../../lib/i18n";

export default function PublicLayout() {
  const [content, setContent] = useState({});
  const { lang } = useParams();

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent(data)).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (lang && !SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to="/fr" replace />;
  }

  return (
    <LangContext.Provider value={lang || "fr"}>
      <div className="grain min-h-screen flex flex-col bg-[#FDFBF7] text-[#2D2A26]">
        <Header pagesVisibility={content.pages_visibility || {}} />
        <main className="flex-1 pt-20 relative z-10">
          <Outlet context={{ content }} />
        </main>
        <Footer content={content.footer || {}} contactInfo={content.contact_info || {}} pagesVisibility={content.pages_visibility || {}} />
        <WhatsAppButton config={content.whatsapp} />
      </div>
    </LangContext.Provider>
  );
}
